module.exports = __webpack_public_path__ + "img/stain.39e6fcc6.webp";